'use client'

import { HomeSocialWallFragment } from '@/components/Home/HomeSocialWall/HomeSocialWall.generated'
import { Heading } from '@desoutter/uikit'
import { useEffect, useState } from 'react'

interface HomeSocialWallProps {
	fragment: HomeSocialWallFragment
	displayTitle?: boolean
}

export default function HomeSocialWall({
	fragment,
	displayTitle = true,
}: HomeSocialWallProps) {
	const [containerId, setContainerId] = useState<string | null>(null)
	const [scriptLoaded, setScriptLoaded] = useState(false)

	useEffect(() => {
		if (!fragment.script) return

		const apiUrl = `/api/curator/container?url=${encodeURIComponent(fragment.script)}`

		fetch(apiUrl)
			.then((response) => {
				if (!response.ok) {
					throw new Error(`API returned ${response.status}`)
				}
				return response.json()
			})
			.then((data) => {
				if (data.success && data.containerId) {
					setContainerId(data.containerId)
				} else {
					throw new Error('Invalid API response')
				}
			})
			.catch(() => {
				setContainerId('curator-feed-default-layout')
			})
	}, [fragment.script])

	useEffect(() => {
		if (!containerId || scriptLoaded) return

		const script = document.createElement('script')
		script.src = `${fragment.script}?${Date.now()}`
		script.async = true
		script.charset = 'UTF-8'

		script.onload = () => {
			setScriptLoaded(true)
		}

		document.body.appendChild(script)

		return () => {
			if (script.parentNode) {
				script.parentNode.removeChild(script)
			}
		}
	}, [containerId, fragment.script, scriptLoaded])

	if (!containerId) {
		return null
	}

	return (
		<div>
			<div className="container-auto py-16">
				<div className="flex flex-col items-center dark:text-foreground">
					{displayTitle && (
						<Heading as="h2" className="mb-12">
							{fragment.title}
						</Heading>
					)}
				</div>
			</div>
			<div id={containerId}>
				<a
					href="https://curator.io"
					target="_blank"
					className="crt-logo crt-tag"
				>
					Powered by Curator.io
				</a>
			</div>
		</div>
	)
}
